<!--设备台账  deviceArchives-->
<template>
  <div class="eventsBody">
    <el-row :gutter="12">
      <el-col :span="9">
        <div class="base">
          <div class="title">基本信息</div>
          <div class="content">
            <div class="li">
              <div class="t">xx冷冻水泵</div>
              <div class="n">设备名称</div>
            </div>
            <div class="li">
              <div class="t">xx冷冻水泵</div>
              <div class="n">设备名称</div>
            </div>
            <div class="li">
              <div class="t">xx冷冻水泵</div>
              <div class="n">设备名称</div>
            </div>
            <div class="li">
              <div class="t">xx冷冻水泵</div>
              <div class="n">设备名称</div>
            </div>
            <div class="li">
              <div class="t">xx冷冻水泵</div>
              <div class="n">设备名称</div>
            </div>
            <div class="li" style=" display: flex; align-items: center; justify-content: center; ">
              更多
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="15">
        <div class="base">
          <div class="title">
            实时负荷
          </div>
          <div class="content" style="height:186px;">
            <vchart style="height: 100%;" ref='vchart'></vchart>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="12" style="margin-top: 12px;">
      <el-col :span="9">
        <div class="box">
          <div class="title">运行状态区</div>
          <div class="content">
            <div class="li">
              <div class="left">1#主水泵</div>
              <el-tag type="success" size="mini">正常</el-tag>
            </div>
            <div class="li">
              <div class="left">1#备用水泵</div>
              <el-tag type="success" size="mini">正常</el-tag>
            </div>
          </div>
        </div>
        <div class="box" style="margin-top: 12px;">
          <div class="title">运行状态区</div>
          <div class="content">
            <div class="li">
              <div class="left">1#主水泵</div>
              <el-input value="657kwh" style="width: 130px;" dir="rtl" disabled size="mini"></el-input>
            </div>
            <div class="li">
              <div class="left">1#备用水泵</div>
              <el-input value="657kwh" style="width: 130px;" dir="rtl" disabled size="mini"></el-input>
            </div>
          </div>
        </div>
        <div class="box" style="margin-top: 12px;">
          <div class="title">运行状态区</div>
          <div class="content">
            <div class="li">
              <div class="left">1#主水泵</div>
              <span>
                <el-tag size="mini" style="margin-right: 10px;">启动</el-tag>
                <el-tag type="danger" size="mini">关闭</el-tag>
              </span>
            </div>
            <div class="li">
              <div class="left">1#备用水泵</div>
              <span>
                <el-tag size="mini" style="margin-right: 10px;">启动</el-tag>
                <el-tag type="danger" size="mini">关闭</el-tag>
              </span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="15">
        <div class="base">
          <div class="title">
            实时数据
          </div>
          <div class="content" style="height:186px;">
            <vchart style="height: 100%;" ref='vchart2'></vchart>
          </div>
        </div>
        <div class="base" style="margin-top: 12px;">
          <div class="title">
            实时电量
          </div>
          <div class="content" style="height:186px;">
            <vchart style="height: 100%;" ref='vchart3'></vchart>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

  import vchart from '@/components/module/chart/vchart.vue'
  export default {
    components: {
      vchart
    },
    data() {
      return {

        value: ''
      }
    },
    methods: {
      // 设备状态分析
      shishfuhe() {
        var option = {
          grid: {
            top: "8% ",
            left: 52,
            right: 25,
            bottom: 26
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow" // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },
          xAxis: {
            splitArea: {
              //坐标轴在 grid 区域中的分隔区域，默认不显示。
              interval: "auto",
              show: false, //是否显示分隔区域
              areaStyle: {
                color: ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"], //分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
                shadowColor: "red", //阴影颜色
                shadowOffsetX: 0, //阴影水平方向上的偏移距离。
                shadowOffsetY: 0, //阴影垂直方向上的偏移距离
                shadowBlur: 10, //图形阴影的模糊大小。
                opacity: 1 //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false
            },
            axisLine: {
              show: false
            },
            z: 99,
            data: [
              "0:00",
              "01:00",
              "02:00",
              "03:00",
              "04:00",
              "05:00",
              "06:00",
              "07:00",
              "08:00",
              "09:00",
              "10:00",
              "11:00",
              "12:00",
            ]
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              data: [120, 280, 150, 80, 70, 110, 230, 280, 150, 80, 70, 110, 230],
              type: "line",
            },
            {
              data: [100, 180, 120, 70, 60, 100, 230, 210, 110, 40, 20, 100, 200, 210],
              type: "line",
            },
          ]
        };

        this.$refs.vchart.setData(option, true);
        this.$refs.vchart2.setData(option, true);


      },
      // 实时电量
      shishdianliang() {
        var option = {
          grid: {
            top: "8% ",
            left: 52,
            right: 25,
            bottom: 26
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow" // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },
          xAxis: {
            splitArea: {
              //坐标轴在 grid 区域中的分隔区域，默认不显示。
              interval: "auto",
              show: false, //是否显示分隔区域
              areaStyle: {
                color: ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"], //分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
                shadowColor: "red", //阴影颜色
                shadowOffsetX: 0, //阴影水平方向上的偏移距离。
                shadowOffsetY: 0, //阴影垂直方向上的偏移距离
                shadowBlur: 10, //图形阴影的模糊大小。
                opacity: 1 //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false
            },
            axisLine: {
              show: false
            },
            z: 99,
            data: [
              "0:00",
              "01:00",
              "02:00",
              "03:00",
              "04:00",
              "05:00",
              "06:00",
              "07:00",
              "08:00",
              "09:00",
              "10:00",
              "11:00",
              "12:00",
            ]
          },
          color: ['#61aaf2'],
          yAxis: {
            type: "value"
          },
          series: [
            {
              data: [120, 280, 150, 80, 70, 110, 230, 280, 150, 80, 70, 40, 60],
              type: 'bar',
              barWidth: 30,//柱图宽度
            }
          ]
        };
        this.$refs.vchart3.setData(option, true);
      },

    },
    mounted() {
      this.shishfuhe()
      this.shishdianliang()

    }
  }
</script>

<style scoped>
  .eventsBody {
    box-sizing: border-box;
    padding: 10px;
  }

  .eventsBody .base {
    background: #fff;
    padding: 10px 15px 15px 15px;
  }

  .eventsBody .box {
    background: #fff;
    padding: 10px 15px 15px 15px;
    height: 123px;
  }

  .eventsBody .base .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .eventsBody .base .content .li {
    width: 30%;
    height: 80px;
    border: 1px solid #d7d7d7;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
  }

  .eventsBody .base .content .li .t {
    color: #5693be;
    font-weight: bold;
    font-size: 15px;
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: center;
  }

  .eventsBody .base .content .li .n {
    height: 30px;
    background-color: #ebecf0;
    line-height: 30px;
    text-align: center;
  }

  .eventsBody .title {
    font-size: 13px;
    font-weight: bold;
    line-height: inherit;
    text-align: left;
    margin: 0;
  }

  .eventsBody .box .content .li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 5px;
    padding: 0 5px;
  }
</style>